<template>
  <div class="login-wrapper">
    <div class="login-container">
      <h2>Connexion</h2>
      <form @submit.prevent="login">
        <input v-model="username" type="text" placeholder="Nom d'utilisateur" required />
        <input v-model="password" type="password" placeholder="Mot de passe" required />
        <button type="submit">Se connecter</button>
      </form>
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
    </div>
  </div>
</template>


<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router"; // ✅ Ajout de useRouter
import {api} from "../api"; // ✅ Importer l'API centralisée

const username = ref("");
const password = ref("");
const errorMessage = ref("");

const emit = defineEmits(["login-success"]);

const router = useRouter(); // ✅ Initialisation correcte

console.log("🔥 Login.vue mounted");

const login = async () => {
  try {
    console.log("🌍 API utilisée :", import.meta.env.VITE_API_URL);

    const response = await api.post("/login", {
      username: username.value,
      password: password.value,
    });

    const token = response.data.token;
    console.log("✅ Token reçu :", token);

    // ✅ Sauvegarde le token + état authentifié
    localStorage.setItem("token", token);
    localStorage.setItem("isAuthenticated", "true");

    // ✅ Forcer le rafraîchissement pour bien mettre à jour l'affichage
    router.push("/");
    setTimeout(() => {
      window.location.reload(); // 🔥 Assure le rechargement et la mise à jour du layout
    }, 100);
  } catch (error) {
    errorMessage.value = "Nom d'utilisateur ou mot de passe incorrect.";
    console.error("❌ Erreur de connexion :", error);
  }
};

</script>


<style scoped>
.login-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh; /* ✅ Centrage vertical */
}

.login-container {
  max-width: 300px;
  padding: 20px;
  background: #1e2126;
  border-radius: 8px;
  text-align: center;
  color: white;
  margin-top: 80px; /* ✅ Espace sous le menu */
}

input {
  display: block;
  width: 100%;
  padding: 8px;
  margin: 10px 0;
  border: none;
  border-radius: 4px;
}

button {
  width: 100%;
  padding: 10px;
  background: #26a69a;
  border: none;
  color: white;
  cursor: pointer;
}

.error {
  color: red;
  margin-top: 10px;
}
</style>
